import Swiper, { Navigation, Pagination, Lazy, Zoom } from 'swiper';

import '../../../node_modules/swiper/swiper.min.css';
import '../../../node_modules/swiper/modules/pagination/pagination.min.css';
import '../../../node_modules/swiper/modules/lazy/lazy.min.css';
import '../../../node_modules/swiper/modules/zoom/zoom.min.css';

export default (
    initialType,
    initialId = {},
    initialTitle = '', 
    initialPrice = 0,
    initialPriceLabel = '',
    initialCompareAtPrice = 0,
    initialCompareAtPriceLabel = '',
) => ({
    type: initialType,
    images: [],
    id: initialId,
    title: initialTitle,
    price: initialPrice,
    priceLabel: initialPriceLabel,
    compareAtPrice: initialCompareAtPrice,
    compareAtPriceLabel: initialCompareAtPriceLabel,
    swiper: null,
    navigationConfig: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    portrait: null, 
    sizeGuideOpen: false,

    init() {
        Swiper.use([Navigation, Pagination, Lazy, Zoom])

        this.images = Array.from(
            document.querySelectorAll('.product-page-template .swiper-slide picture'),
            picture => ({
                source: picture.querySelector('source').srcset,
                src: picture.querySelector('img').src,
                alt: picture.querySelector('img').alt,
                title: this.type === 'Strap' ? this.strapVariantTitle(picture.querySelector('img').alt) : ''
            })
        )

        this.hideUnselectedStraps()

        if (!this.isDesktop()) {
            this.initSwiper()
        }

        const slides = this.slides()

        slides.forEach((slide, index) => 
            slide.addEventListener('click', e => {
                if (this.isDesktop() && !this.$store.productLightboxActive) {
                    this.initSwiper(
                        index, 
                        true,
                        this.navigationConfig,
                        'fraction'
                    )
                }
            })
        )

        window.addEventListener('resize', () => {
            if (this.swiper && this.isDesktop()) {
                this.destroySwiper()
            } else if ((!this.swiper || this.swiper.destroyed) && !this.isDesktop()) {
                this.initSwiper()
            }
        })
    },

    addToCart(quantity = 1) {
        const formData = {
            items: [{
                id: this.id,
                quantity: quantity
            }]
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            this.$store.cart.fetchCart()
            this.$store.cart.toggle(true)
        })
        .catch((error) => {
            console.error('Add to cart error:', error)
        })
    },
    updateVariant(id, title, price, priceLabel, compareAtPrice, compareAtPriceLabel) {
        this.id = id
        this.title = title
        this.compareAtPrice = compareAtPrice
        this.compareAtPriceLabel = compareAtPriceLabel

        if (price !== this.price) {
            this.price = price
            this.priceLabel = priceLabel
            this.updateKlarna()
        }

        if (this.type === 'Strap') {
            this.updateCurrentSlideImage()
        }

    },
    updateKlarna() {
        document.getElementsByTagName('klarna-placement')[0].setAttribute('data-purchase-amount', this.price);
        window.Klarna.OnsiteMessaging.refresh()
    },
    strapVariantTitle(imageAlt) {
        const alt = imageAlt.toLowerCase()
        const regex = /\d{2}mm/g
        const match = alt.match(regex)
        return match[0] ?? ''
    },
    hideUnselectedStraps() {
        if (this.type !== 'Strap') return

        const slides = this.slides()

        slides.forEach(slide => {
            const image = slide.querySelector('img')
            const alt = image.getAttribute('alt')
            const title = this.strapVariantTitle(alt)

            if (title !== this.title) {
                slide.remove()
            }
        })
    },
    updateCurrentSlideImage() {
        const newImageData = this.images.find(imageData => imageData.title === this.title)
        const picture = document.querySelector('.product-page-template .swiper-slide picture')
        const pictureSource = picture.querySelector('source')
        const image = picture.querySelector('img')

        pictureSource.srcset = newImageData.source
        image.src = newImageData.src
        image.alt = newImageData.alt
    },


    //-------------------------------------------------------------------------
    // SwiperJS methods
    //-------------------------------------------------------------------------
    initSwiper(initialSlideIndex = 0, lightbox = false, navigation = false, paginationType = 'bullets') {
        const hasMultipleSlides = this.slides().length > 1

        this.swiper = new Swiper('.product-carousel', {
            initialSlide: initialSlideIndex,
            slidesPerView: 1,
            loop: hasMultipleSlides ? true : false,
            preloadImages: false,
            watchSlidesProgress: true,
            zoom: {
                maxRatio: 1.5,
                toggle: false
            },
            lazy: {
                checkInView: true,
                loadPrevNext: true,
                loadOnTransitionStart: true
            },
            keyboard: {
                enabled: true
            },
            navigation: navigation,
            pagination: {
                el: '.swiper-pagination',
                type: paginationType,
                bulletActiveClass: 'bg-white opacity-100'
            },
            on: {
                click: function (swiper, event) {
                    swiper.zoom.toggle()
                },
                beforeDestroy: function (swiper) {
                    swiper.slides.forEach(slide => {
                        const zoomContainer = slide.querySelector('.swiper-zoom-container')
                        const picture = zoomContainer.querySelector('picture')
                        const image = zoomContainer.querySelector('img')

                        Array.from([zoomContainer, picture, image]).forEach(element => element.removeAttribute('style'))
                    })
                }
            }
        })

        this.$store.productLightboxActive = lightbox

        if (lightbox) {
            this.portrait = this.isPortrait()
        }
    },
    destroySwiper() {
        if (this.swiper && !this.swiper.destroyed) {
            this.swiper.destroy()
            this.$store.productLightboxActive = false
        }
    },
    slides() {
        return document.querySelectorAll('.product-page-template .swiper-slide')
    },
    isDesktop() {
        return window.matchMedia('(min-width: 1024px)').matches
    },
    isPortrait() {
        return window.matchMedia('(orientation: portrait)').matches
    }
})
